import Environment from '@di-shared/features/environment/Environment';
import Kr from '@di-shared/features/history/driving-info/DrivingInfoFuel/.kr';

export interface DrivingInfoFuelProps {
  vin: string;
  selectedDate: Date;
}

export default function DrivingInfoFuel({vin, selectedDate}: DrivingInfoFuelProps) {
  return (
    <>
      <Environment.Kr>
        <Kr
          vin={vin}
          selectedDate={selectedDate}
        />
      </Environment.Kr>
    </>
  );
}
